export const env = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000',
  defaultProvider: import.meta.env.VITE_DEFAULT_PROVIDER || 'openai',
  appName: import.meta.env.VITE_APP_NAME || 'Multi AI Chat',
  appLogoUrl: import.meta.env.VITE_APP_LOGO_URL || '',
} as const;
